<template>
  <div class="p-contentplans-writing-user-headings" ref="block">
    <div class="p-contentplans-writing-user-headings__header">
      <h4 class="p-contentplans-writing__title--sub">見出し構成案</h4>
      <ul
        class="p-contentplans-writing__note p-contentplans-writing-user-headings__counts"
      >
        <li>
          h1～h3の総数:<span class="p-contentplans-writing__count">{{
            headingsLength.h123
          }}</span
          >個
        </li>
        <li>
          h1:<span class="p-contentplans-writing__count">{{
            headingsLength.h1
          }}</span
          >個
        </li>
        <li>
          h2:<span class="p-contentplans-writing__count">{{
            headingsLength.h2
          }}</span
          >個
        </li>
        <li>
          h3:<span class="p-contentplans-writing__count">{{
            headingsLength.h3
          }}</span
          >個
        </li>
      </ul>
    </div>
    <template v-if="isEditMode">
      <slot></slot>
      <div class="c-alertPos">
        <UserHeadingsList
          :errorAddHeading="errorAddHeading"
          :errors="errors"
          :items="headings"
          ref="list"
          @input="inputHeading"
          @insertHeading="insertHeading"
          @remove="removeHeading"
        />
        <Alert v-if="errors.maxLength">{{ errors.maxLength }}</Alert>
      </div>
      <div
        v-if="isEditMode"
        class="p-contentplans-writing-user-headings__buttons"
      >
        <div class="c-alertPos">
          <UserHeadingsButtonAdd level="h2" @click="addHeading('h2', '')" />
          <Alert v-if="error.add.h2" variant="center">{{ error.add.h2 }}</Alert>
        </div>
        <div class="c-alertPos">
          <UserHeadingsButtonAdd level="h3" @click="addHeading('h3', '')" />
          <Alert v-if="error.add.h3" variant="center">{{ error.add.h3 }}</Alert>
        </div>
        <div class="c-alertPos">
          <UserHeadingsButtonAdd level="h4" @click="addHeading('h4', '')" />
          <Alert v-if="error.add.h4" variant="center">{{ error.add.h4 }}</Alert>
        </div>
      </div>
    </template>
    <template v-else>
      <UserHeadingsViewList :h1="h1" :headings="headings" />
    </template>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import UserHeadingsButtonAdd from '@/components/contentPlans/writing/UserHeadingsButtonAdd';
import UserHeadingsList from '@/components/contentPlans/writing/UserHeadingsList';
import UserHeadingsViewList from '@/components/contentPlans/writing/UserHeadingsViewList';

export default {
  props: {
    errorAddHeading: {
      type: String,
      required: false
    },
    errors: {
      type: Object,
      required: true
    },
    h1: {
      type: String,
      required: true
    },
    headings: {
      type: Array,
      required: true
    },
    headingsLength: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Alert,
    UserHeadingsButtonAdd,
    UserHeadingsList,
    UserHeadingsViewList
  },
  data() {
    return {
      error: {
        add: {
          h2: '',
          h3: '',
          h4: ''
        }
      },
      timeoutId: null
    };
  },
  computed: {
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    }
  },
  watch: {
    errorAddHeading: {
      handler(value) {
        if (!value) {
          // 見出しが追加できるようになったらエラーメッセージを消す
          this.clearErrorAdd();
        }
      }
    },
    notificationsHeight: {
      handler() {
        this.setHeight();
      }
    }
  },
  mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
    window.removeEventListener('resize', this.setHeight);
  },
  methods: {
    addHeading(level, value) {
      if (this.errorAddHeading) {
        this.clearErrorAdd();
        this.error.add[level] = this.errorAddHeading;

        this.timeoutId = setTimeout(() => {
          this.error.add[level] = '';
        }, 2000);

        return;
      }
      this.$emit('addHeading', level, value);
    },
    clearErrorAdd() {
      clearTimeout(this.timeoutId);
      for (const key in this.error.add) {
        this.error.add[key] = '';
      }
    },
    focusLastInput() {
      this.$nextTick(() => {
        const items = this.$refs.list.$refs.items;
        items[items.length - 1].$refs.input.$el.focus();
      });
    },
    inputHeading(id, level, value) {
      this.$emit('inputHeading', id, level, value);
    },
    insertHeading(id, level, value) {
      this.$emit('insertHeading', id, level, value);
    },
    removeHeading(id) {
      this.$emit('removeHeading', id);
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const list = this.$refs.list.$el;
        list.scrollTop = list.scrollHeight;
      });
    },
    setHeight() {
      if (!this.$refs.block || !this.$refs.list) return;

      const blockHeight = this.$refs.block.clientHeight;
      const listHeight = this.$refs.list.$el.clientHeight;
      const widgetHeight = 100;

      const maxHeight =
        document.documentElement.clientHeight -
        this.notificationsHeight -
        (blockHeight - listHeight) -
        widgetHeight;

      this.$refs.list.$el.style.maxHeight = maxHeight + 'px';
    }
  }
};
</script>
